module.exports = __webpack_public_path__ + "img/iaamc.115edeb7.png";